import axios from "axios";
import { Navigate } from "react-router-dom";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export async function schoolstatementview(id) {
  try {
    return await axios
    .get(`${baseUrl}/cms/view-school-statement?school_id=${id}&school_or_funder=2`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function funderdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-mfunder?funder_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function funderschoollist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/funder-school-list?funder_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function fundertourlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/tournament-event-list-funder?funder_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function fundergallerylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/gallery-list-funder?funder_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Success Stories
export async function storylist(id,type) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-success-stories?school_id=${id}&school_or_funder=${type}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function storyview(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-success-stories?article_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function funderresourceslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-resources-funder?funder_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Photos List tournament
export async function photoslist(id) {
  try {
    
    return await axios
      .get(`${baseUrl}/tournamentimagelist/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function tourdetails(id) {
  try {
    return await axios
      .get(`${baseUrl}/meet-view-details/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events List
export async function athletictourordereventslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/athletics-events-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Category List for tournament
export async function tourcategorylist(data) {
  try {
    return await axios
      .post(`${baseUrl}/team-category-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Category List wise fixtures
export async function tourcategoryfixtures(id,cid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/get-fixtures?tournament_id=${id}&category_id=${cid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Entry list
export async function tourpointslist(id, cid,pid) {
  try {
    return await axios
      .get(`${baseUrl}/tournament-points-table-view/${id}/${cid}/${pid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Teams list
export async function tourteamslist(id, cid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/teamlist/${id}/${cid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament team list
export async function tourteamplayerlist(id, tid) {
  try {
    
    return await axios
      .get(`${baseUrl}/cms/team-player-list/${id}/${tid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//athletics inter tournament entry list
export async function athleticsintertourentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/inter-school-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//athletics intra tournament entry list
export async function athleticsintratourentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/intra-school-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

 //Play Session
 export async function playsessionview(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-play-sessions?school_id=${id}&school_or_funder=2`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function poollisttour(id, eid) {
  try {
    return await axios
      .get(`${baseUrl}/pool/poollist/${id}/${eid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Medal 
export async function fundermedalslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/funder-schools-achievements-summary`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Overall Champion List
export async function agecategorychampionslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/overall-individual-champions-list-with-funder-group`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Overall Champion List
export async function agecategoryindchampionslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/individual-champions-list-by-age-cat-funder-group`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



export async function trackingdata(data) {
  try {
   
    return await axios
      .post(`${baseUrl}/track-user-info-for-webpage`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Except Heat Start List
export async function athletictoureventstartexceptheatlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/get-start-list-of-athletics-except-heat`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Start List -- time/distance list
export async function athleticstartresultlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/get-results-data-for-cms`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function schooldetails(id) {
  try {
    
    return await axios
      .get(`${baseUrl}/mschool/view-school-based-on-chid/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//External Photos List tournament
export async function exteventphotoslist(id,type) {
  try {
  
    return await axios
      .get(`${baseUrl}/other-tournament-event-list/${id}/${type}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Event List
export async function othereventdetails(id) {
  try {
    return await axios
      .get(`${baseUrl}/otherevent/event-view-details/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament entry list
export async function eventplayerentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/other-event-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//View External Tournament
export async function externaltourdetails(id) {
  try {
    
    return await axios
      .get(`${baseUrl}/view-external-tournament-by-coach/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights List tournament
export async function highlightslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/meet-highlightlinks-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Medal Degails
export async function medalsdetaillist(fid,stst) {
  try {
    return await axios
      .get(`${baseUrl}/cms/get-achievements-based-on-funder?school_funder_group_id=${fid}&school_funder_group=${stst}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Testimonials List
export async function cmsfundermoniallist(id,fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-testimonials?school_funder_group_id=${id}&school_or_funder_or_group=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Coach profile list
export async function cmsfundercoachlist(id,fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-coach-profiles?school_funder_group_id=${id}&school_or_funder_or_group=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Testimonial view
export async function cmsfundermonialdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-testimonials?testimonial_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Coach profile view
export async function cmsfundercoachdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-coach-profiles?profile_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //       window.location.reload();
      //   }
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
